// const host = "http://localhost:7001";
const host = "https://tutorplatter-back.softvisionary.com";
const ioPort = 6001;

const mainColor = "#7ED958";
const v = "v1";
module.exports = { host, v, mainColor, ioPort };